module.exports = __webpack_public_path__ + "static/media/bockDammMug.f0c80246.jpg";